import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { overlay } from './modules/overlay.js';
import { accordion } from './modules/accordion.js';
import { scrollTop } from './modules/scroll-top.js';
import { drawer } from './modules/drawer.js';
import { tabs } from './modules/tabs.js';
import { customerVoiceSwiper } from './modules/customer-voice-swiper.js';
import { pricePlansSwiper } from './modules/price-plans-swiper.js';
import { addLoadedClass } from './modules/add-loaded-class.js';
import { noticeBarFade } from './modules/notice-bar-fade.js';
import { popup } from './modules/popup.js';
import { contactForm7Debug } from './modules/contact-form-7-debug.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  delayedScroll();
  disableTelOnPC();
  overlay();
  accordion();
  scrollTop();
  drawer();
  tabs();
  customerVoiceSwiper();
  pricePlansSwiper();
  addLoadedClass();
  noticeBarFade();
  popup();
  contactForm7Debug();
});
